import { useFormContext, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import { validatePhoneNumber } from '../ValidateFunctions'
import PhoneNumberInput from './FormInputs/PhoneNumberInput';

FormPhoneNumberField.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
}

export default function FormPhoneNumberField({ fieldName, focusedField, setFocusedField, fieldAttributes }) {
  const { control } = useFormContext();

  return <Controller
    name={fieldName}
    control={control}
    rules={{
      validate: value => validatePhoneNumber(value)
    }}
    render={() => (
      <PhoneNumberInput
        fieldName={fieldName}
        focusedField={focusedField}
        setFocusedField={setFocusedField}
        fieldAttributes={fieldAttributes}
      />
    )}
  />
}